import React from 'react';
import { Route, Redirect, useLocation } from 'wouter';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  path: string;
  component: React.ComponentType<any>;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  path, 
  component: Component 
}) => {
  const { isAuthenticated, isLoading } = useAuth();
  const [location] = useLocation();
  // log isAuthenticated and isLoading and location for debugging
  console.log('ProtectedRoute:', { isAuthenticated, isLoading, location });
  
  return (
    <Route path={path}>
      {(params) => {
        if (isLoading) {
          return (
            <div className="flex items-center justify-center min-h-screen">
              <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
          );
        } else if (!isAuthenticated) {
          return <Redirect to="/auth" />;
        } else {
          // User is authenticated, render the component
          return <Component {...params} />;
        }
      }}
    </Route>
  );
};

export default ProtectedRoute;
